export const css = {
	root: '_1USzKT2c',
	progressBlock: 'mRD1F1kJ',
	cutscoreBlock: 'kwnGwmx4',
	heading: '_2aKhlhqh',
	progress: 'vdvqjuuM',
	chartareaWrapper: '_37_HE46O',
	chartarea: 'wf0TiHP7',
	itemWrapper: 'WiTuz1qI',
	item: '_14j7cUMl',
	emptyTitleBlock: '_3xOw9Bwr',
	' _key': 'quiz-widgets/module-results'
};

export default css;
